import { Component, ElementRef, Inject, OnDestroy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { SnackbarData } from '../../../core/models/snackbar-data';
import { SnackBarService } from '../../../core/services/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { LottieComponent } from 'ngx-lottie';
import { lottieAnimation } from '../../../core/utils';
import { SnackbarMessageType } from '../../../core/enums';
import { AnimationConfig } from 'lottie-web';

@Component({
  selector: 'ling-notification',
  standalone: true,
  imports: [CommonModule, LottieComponent],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnDestroy {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: SnackbarData,
    public snackbarService: SnackBarService,
    public elementRef: ElementRef,
    private translateService: TranslateService
  ) {
    // A way to pass value from JS to CSS
    (elementRef.nativeElement as HTMLElement).style.setProperty(
      '--duration',
      this.data.duration + 'ms'
    );
  }

  protected lottieAnimations: Record<
    SnackbarMessageType,
    Partial<AnimationConfig> | null
  > = {
    [SnackbarMessageType.Success]: lottieAnimation('success', { loop: false }),
    [SnackbarMessageType.Error]: lottieAnimation('fail', { loop: false }),
    [SnackbarMessageType.Warn]: null,
  };

  get dismissText(): string {
    switch (this.data.type) {
      case 'success':
        return this.translateService.instant('snackBar.successDismiss');
      case 'warn':
        return this.translateService.instant('snackBar.warnDismiss');
      case 'error':
        return this.translateService.instant('snackBar.errorDismiss');
      default:
        return this.translateService.instant('snackBar.errorDismiss');
    }
  }

  dismiss(event: MouseEvent): void {
    if (event.ctrlKey) {
      this.snackbarService.resetQueue();
    } else {
      this.snackbarService.currSnackbar$.value?.dismiss();
    }
  }

  ngOnDestroy() {
    if (
      this.data.queuePosition ===
      this.snackbarService.messageCallsQueueLength$.value
    ) {
      this.snackbarService.messageCallsQueueLength$.next(0);
      this.snackbarService.currSnackbar$.next(null);
    }
  }
}
